import {createRef, useState} from "react";
import useFetch from "../../tools/UseFetch";
import config from "../../config/config.json";
import axios from "axios";
import {Window} from "@progress/kendo-react-dialogs";
import {Splitter, StackLayout} from "@progress/kendo-react-layout";
import {ExternalDropZone, Upload} from "@progress/kendo-react-upload";

const FileInDetail = props => {

    const uploadRef = createRef();
    const [refNum, setRefNum] = useState(0)

    const orientation = props.orientation || "horizontal"


    const {data:files, isPending, error} = useFetch(config.API_URL + 'file/' + props.filesFor.UID, refNum)

    const formatter = new Intl.DateTimeFormat('cs-CZ')

    const onBeforeUpload = (event) => {
        event.additionalData.description = "File upload";
        event.additionalData.forUID = props.filesFor.UID;
    };
    const onBeforeRemove = (event) => {
        event.additionalData.description = "File remove";
    };

    const  removeFile  = async file => {
        try {
            const response = await axios.delete(config.API_URL + 'file/' + file.ID, {headers: {'x-api-key': sessionStorage.getItem("apiKEY")}});
            //set((state) => state.loadCashflowForClient(state.ClientID))
            setRefNum(refNum + 1)
        } catch (error) {

        }
    }

    const onStatusChange = (event) => {
        setRefNum(refNum + 1)
        console.log(event)
    };


    const icons = {
        '.pdf':'k-i-pdf',
        '.doc':'k-i-doc',
        '.docx':'k-i-doc',
        '.xls':'k-i-xls',
        '.xlsx':'k-i-doc',
        '.txt':'k-i-txt',
        '.csv':'k-i-csv',
        '.exe':'k-i-exe',
        '.psd':'k-i-psd',
        '.ppt':'k-i-ppt',
        '.pptx':'k-i-ppt',
        '.avi':'k-i-film',
        '.mpg':'k-i-film',
        '.mp4':'k-i-film',
        '.mpeg':'k-i-film',
        '.jpg':'k-i-image',
        '.jpeg':'k-i-image',
        '.png':'k-i-image',
        '.bmp':'k-i-image',
        '.tiff':'k-i-image',
    }

    return(
        <>

                {/*<StackLayout*/}
                {/*    style={{*/}
                {/*        height: "100%",*/}
                {/*        width: "100%",*/}
                {/*        backgroundColor: "red"*/}
                {/*    }}*/}
                {/*    orientation={orientation}*/}
                {/*    gap={0}*/}
                {/*>*/}

            <div className={"details-page-" + orientation}>

                    <div className={"file-upload-inDetail-" + orientation}>


                        <Upload
                            ref={uploadRef}
                            batch={true}
                            multiple={true}
                            // defaultFiles={[]}
                            // files={files}
                            onBeforeUpload={onBeforeUpload}
                            onBeforeRemove={onBeforeRemove}
                            onStatusChange={onStatusChange}
                            withCredentials={false}
                            saveUrl={config.API_URL + "file/"}
                            // removeUrl={"http://localhost:8099/api/file/"}
                            removeMethod={"DELETE"}
                            saveHeaders={{'x-api-key': sessionStorage.getItem("apiKEY")}}
                            removeHeaders={{'x-api-key': sessionStorage.getItem("apiKEY")}}
                            showFileList={false}
                        />

                        <ExternalDropZone uploadRef={uploadRef}/>

                        {/*<div*/}
                        {/*    style={{*/}
                        {/*        height: "50px",*/}
                        {/*    }}*/}
                        {/*/>*/}

                    </div>


                    <div className={"file-list-inDetail-" + orientation}>
                        {files && <>

                            {files.map(f => (
                                <div key={f.ID} className="file-row">
                                    <a className="file-row-a" href={config.FILE_URL + f.RelPath} target="_blank"><span className={"k-icon " + (icons[f.Type] || "k-i-file")} style={{fontSize: 50 + 'px'}} />
                                        <span className="file-row-name">{f.Name}</span>
                                        <span className="file-row-info">{new Date(f.CreatedAt).toLocaleString('cz-CZ')}, {f.Size} B</span></a>
                                    <span className="file-row-remove">

                                        <span className="k-icon k-i-x-circle red" style={{fontSize: 25 + 'px'}} onClick={() => removeFile(f)} />

                                    </span>
                                </div>
                            ))}

                        </>}
                    </div>

                {/*</StackLayout>*/}

            </div>

        </>
    )
}

export default FileInDetail